import React, { Component } from 'react';
import { Toast, WhiteSpace } from 'antd-mobile';
import { Select } from 'antd';
import axios from "axios";
import url from "url";
import logo from "../assects/img/logo.png";
import storage from "../model/storage";
import "../assects/css/login.css";
class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loginSuccess: false,
      user_name: "",
      user_phone: "",
      codeDis: false,
      code_num: "获取验证码",
      user_code: "",
      pro_list: [],
      city_list: [],
      proVal: "",
      cityVal: "",
      stagesVal:"",
      subjectVal:"",
      unitVal: undefined,
      majorVal:"",
      jgTxt: '请输入昵称',
      jgTxtPhone:'请输入您的电话号码',
      jgTxtCode: "验证码不能为空，请输入您的验证码",
      jgTxtPro: "请选择报考地",
      jgTxtSub:"请选择学",
      jgTxtUnit:"请选择单位",
      jgTxtMajor:"请选择专业",
      nameJg: false,
      phoneJg: false,
      codeJg: false,
      adrJg: false,
      subJg:false,
      unitJg:false,
      majorJg:false,
      examId: "",
      paperId: "",
      channel: "",
      paperInfo: {},
      examTypeId: "",
      btnDis: false,
      examType: "1",
      lockState: false,
      stagesArr:[],
      subjectArr:[],
      // {id: '山楂', label: '山楂'},{id: '果冻', label: '果冻'},{id: '麻椒鸡', label: '麻椒鸡'}
      unitArr:[],
      majorArr:[],
      selectPid: 0,
      unitId:"",
      unitName:"",
      majorId:"",
      majorName:"",
      market:'',
      isArea:'',
      isCity:''
    }
  }

  componentDidMount() {
    //预留 获取试卷id 和 考试id100000007 45 
    let examId = url.parse(this.props.location.search, true).query.examId;
    let paperId = url.parse(this.props.location.search, true).query.paperId;
    let channel = url.parse(this.props.location.search, true).query.channel ? url.parse(this.props.location.search, true).query.channel : '';
    let market = url.parse(this.props.location.search, true).query.market? url.parse(this.props.location.search, true).query.market : '';
    //this.props.history.push( { pathname: "/Countdown", state: {examType:'0', examId:100000025,paperId:131,userId:19513} });

    // console.log(url.parse(this.props.location.search, true).query);
    //console.log(paperId);
    if (examId === "" || examId === undefined || paperId === "" || paperId === undefined || market === "") {
      Toast.info('获取试卷信息错误!', 1);

    } else {
      var that = this;
      that.setState({
        examId: examId,
        paperId: paperId,
        channel: channel,
        market:market
      })
      storage.set("examId", examId);
      storage.set("paperId", paperId);
      storage.set("channel", channel);
      storage.set("market", market);
      axios.get(storage.baseUrl + '/indexData', {
        params: {
          examId: examId,
          paperId: paperId,
          market:market
        }
      })
        .then(function (response) {
          // handle success
          if ((response.data.code !== "0000" && response.data.code !== "0102" && response.data.code !== "0001")) {
            // Toast.info(response.data.message, 2);
            
            that.setState({
              examTypeId: response.data.examInfo.typeId,
              isCity:response.data.examInfo.city,
              paperInfo: response.data.paperInfo,
              pro_list: response.data.regnInfos?response.data.regnInfos:[],
              isArea:response.data.paperInfo.isArea,
              examType: response.data.examInfo.examType,
              btnDis: true,
              codeDis: true,
              stagesArr:(response.data.paperInfo&&response.data.paperInfo.stages&&that.handleSpace(response.data.paperInfo.stages))?that.findElem((response.data.paperInfo.stages).replace(/\s+/g,'')):[],
              subjectArr:(response.data.paperInfo&&response.data.paperInfo.subject&&that.handleSpace(response.data.paperInfo.subject))?that.findSubject((response.data.paperInfo.subject).replace(/\s+/g,'')):[]
            })
           
            if (response.data.code === "0104") {
              setTimeout(() => {
                that.props.history.push({ pathname: "/Result", state: { examType: response.data.examInfo.examType, examId: that.state.examId, paperId: that.state.paperId, userId: response.data.userId } });
              }, 200);
            }
            if (response.data.code === "0107") {
              setTimeout(() => {
                that.props.history.push({ pathname: "/Countdown", state: { examType: response.data.examInfo.examType, examId: that.state.examId, paperId: that.state.paperId, userId: response.data.userId } });
              }, 200);
            }
            // if (response.data.code === "0103") {
            //   if (that.state.examType === "1") {
            //     setTimeout(() => {
            //       that.props.history.push({ pathname: "/MKSelf", state: { examType: response.data.examInfo.examType, examId: that.state.examId, paperId: that.state.paperId, userId: response.data.userId } });
            //     }, 200);
            //   }else{
            //     setTimeout(() => {
            //       that.props.history.push({ pathname: "/Result", state: { examType: response.data.examInfo.examType, examId: that.state.examId, paperId: that.state.paperId, userId: response.data.userId } });
            //     }, 200);
            //   }
            // }
          } else {
            that.setState({
              examTypeId: response.data.examInfo.typeId,
              isCity:response.data.examInfo.city,
              paperInfo: response.data.paperInfo,
              pro_list: response.data.regnInfos?response.data.regnInfos:[],
              isArea:response.data.paperInfo.isArea,
              examType: response.data.examInfo.examType,
              stagesArr:(response.data.paperInfo&&response.data.paperInfo.stages&&that.handleSpace(response.data.paperInfo.stages))?that.findElem((response.data.paperInfo.stages).replace(/\s+/g,'')):[],
              subjectArr:(response.data.paperInfo&&response.data.paperInfo.subject&&that.handleSpace(response.data.paperInfo.subject))?that.findSubject((response.data.paperInfo.subject).replace(/\s+/g,'')):[]
            })
            // console.log(that.handleSpace(response.data.paperInfo.subject),'11111111',that.handleSpace(response.data.paperInfo.stages))
            if (response.data.code === "0000") {
              if (that.state.examType === "0") {
                setTimeout(() => {
                  that.props.history.push({ pathname: "/GF", state: { examType: response.data.examInfo.examType, examId: that.state.examId, paperId: that.state.paperId, userId: response.data.userId } });

                }, 200);
              } else {
                setTimeout(() => {
                  that.props.history.push({ pathname: "/MK", state: { examType: response.data.examInfo.examType, examId: that.state.examId, paperId: that.state.paperId, userId: response.data.userId } });

                }, 200);
              }
            }
            if(response.data.examInfo.typeId=='1036'){
              that.getUnitArr(examId,true)
            }
          }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })


    }   




  }
  componentWillReceiveProps(nextProps) {
    // console.log(nextProps);
  }
  
  userName = () => {
    this.setState({
      nameJg: false,
      user_name: this.refs.nameVal.value
    })
  }
  userPhone = () => {
    this.setState({
      phoneJg: false,
      user_phone: this.refs.phoneVal.value
    })
  }
  ckName = () => {
    if (this.state.user_name === "") {
      this.setState({
        jgTxt: "昵称不能为空，请输入您的昵称",
        nameJg: true
      })
      return false;
    } else {
      this.setState({
        jgTxt: "",
        nameJg: false
      })
      return true;
    }
  }
  ckPhone = () => {
    let myreg = /^(1[3-9])\d{9}$/;
    if (this.state.user_phone === "") {
      this.setState({
        jgTxtPhone: "手机号不能为空，请输入您的手机号",
        phoneJg: true
      })
      return false;
    } else {
      if (!myreg.test(this.state.user_phone)) {
        this.setState({
          jgTxtPhone: "手机号码格式不正确，请重新输入",
          phoneJg: true
        })
        return false;
      } else {
        this.setState({
          phoneJg: false
        })
        return true;
      }
    }
  }
  getcode = () => {
    if (this.ckName() && this.ckPhone()) {
      var that = this;
      that.setState({
        code_num: "120s",
        codeDis: true

      })
      let code_num = 119;
      let getDao = setInterval(() => {
        if (code_num > 1) {
          this.setState({
            code_num: code_num + "s"
          })
          code_num--;
        } else {
          that.setState({
            code_num: "获取验证码",
            codeDis: false
          })
          clearInterval(getDao);
        }
      }, 1000)

      axios.post(storage.baseUrl + '/sendCode', "mobile=" + that.state.user_phone)
        .then(function (response) {
          // handle success
          //console.log(response.data);
          if (response.data.code !== "0000") {
            that.setState({
              jgTxtCode: response.data.msg,
              codeJg: true,
              code_num: "获取验证码",
              codeDis: false
            })
            clearInterval(getDao);
          } else {
            Toast.info('发送成功', 1);
          }

        })
        .catch(function (error) {
          // handle error
          console.log(error);
        })

    }


  }
  userCode = (e) => {
    this.setState({
      codeJg: false,
      user_code: e.target.value
    })
  }
  ckCode = () => {
    if (this.state.user_code === "") {
      this.setState({
        jgTxtCode: "验证码不能为空，请输入您的验证码",
        codeJg: true
      })
      return false;
    } else {
      this.setState({
        jgTxtCode: "",
        codeJg: false
      })
      return true;
    }
  }
  ckAdr = () => {
    //console.log(this.state.cityVal);
    if (this.state.cityVal === "") {
      this.setState({
        jgTxtPro: "请选择报考地",
        adrJg: true
      })
      return false;
    } else {
      this.setState({
        jgTxtPro: "",
        adrJg: false
      })
      return true;
    }
  }
  ckStages = ()=>{
    if(this.state.examTypeId!="1036"){
      if(this.state.subjectArr.length>0&&this.state.stagesArr.length>0){
        if(this.state.stagesVal!==""&&this.state.subjectVal!==""){
          this.setState({
            jgTxtSub: "",
            subJg: false
          })
          return true;
        }else if(this.state.stagesVal===""){
          this.setState({
            jgTxtSub: "请选择学段",
            subJg: true
          })
          return false;
        }else{
          this.setState({
            jgTxtSub: "请选择学科",
            subJg: true
          })
          return false;
        }
      }else if(this.state.stagesArr.length>0&&this.state.subjectArr.length==0){
        if(this.state.stagesVal!==""){
          this.setState({
            jgTxtSub: "",
            subJg: false
          })
          return true;
        }else{
          this.setState({
            jgTxtSub: "请选择学段",
            subJg: true
          })
          return false;
        }
      }else if(this.state.subjectArr.length>0&&this.state.stagesArr.length==0){
        if(this.state.subjectVal!==""){
          this.setState({
            jgTxtSub: "",
            subJg: false
          })
          return true;
        }else{
          this.setState({
            jgTxtSub: "请选择学科",
            subJg: true
          })
          return false;
        }
      }else{
        this.setState({
          jgTxtPro: "",
          subJg: false
        })
        return true;
      }
    }else{
      this.setState({
        jgTxtPro: "",
        subJg: false
      })
      return true;
    }  
  }
  ckUnit = ()=>{
    if(this.state.examTypeId=="1036"){
      // console.log(this.state.unitVal,'hahahah')
      if(this.state.unitVal===undefined){
        this.setState({
          jgTxtUnit: "请选择单位",
          unitJg: true
        })
        return false;
      }else{
        this.setState({
          jgTxtUnit: "",
          unitJg: false
        })
        return true;
      }
    }else{
      this.setState({
        jgTxtUnit: "",
        unitJg: false
      })
      return true;
    }
  }
  ckMajor = ()=>{
    if(this.state.examTypeId=="1036"){
      if(this.state.majorVal===""){
        this.setState({
          jgTxtMajor: "请选择专业",
          majorJg: true
        })
        return false;
      }else{
        this.setState({
          jgTxtMajor: "",
          majorJg: false
        })
        return true;
      }
    }else{
      this.setState({
        jgTxtMajor: "",
        majorJg: false
      })
      return true;
    }
  }
  proVal = (e) => {
    let all_city = [{ regnNm: "不限", regnCode: "0" }];
    this.setState({
      adrJg: false,
      proVal: e.target.value,
      cityVal: ""
    })
    var that = this;
    var param = {};
    (this.state.isCity)/1==1?(param.regnCode=e.target.value):(param.regnCode2=this.state.isCity)
    // console.log(param,'param',this.state.isCity)
    axios.get(storage.baseUrl + '/queryCity', {      
      params:param
    })
      .then(function (response) {
        // handle success
        //console.log(typeof (response.data[0].suprRegnCode));

        if ('110100120100310000500000'.indexOf(response.data[0].suprRegnCode) !== -1) {
          that.setState({
            city_list: all_city
          })
        } else {
          that.setState({
            city_list: response.data
          })
        }

      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .then(function () {
        // always executed
      });
    // axios.get(storage.baseUrl + '/queryCityDatas', {
    //   params: {
    //     id: e.target.value

    //   }
    // })
    //   .then(function (response) {
    //     // handle success
    //     //console.log(typeof (response.data[0].suprRegnCode));

    //     if ('110100120100310000500000'.indexOf(response.data[0].suprRegnCode) !== -1) {
    //       that.setState({
    //         city_list: all_city
    //       })
    //     } else {
    //       that.setState({
    //         city_list: response.data
    //       })
    //     }

    //   })
    //   .catch(function (error) {
    //     // handle error
    //     console.log(error);
    //   })
    //   .then(function () {
    //     // always executed
    //   });

  }
  cityVal = (e) => {
    this.setState({
      adrJg: false,
      cityVal: e.target.value
    })
  }
  stagesVal = (e) =>{
    this.setState({
      // subJg: false,
      stagesVal: e.target.value
    })
  }
  subjectVal = (e) =>{
    this.setState({
      // subJg: false,
      subjectVal: e.target.value
    })
  }
  unitVal =(e)=>{
    const valStr = e.target.value;
    let value=valStr ? JSON.parse(valStr) : "";
    // console.log(value,'value')
    this.setState({
      unitId:value.id,
      unitName:value.name,
      unitVal: valStr
    })
    if(value&&value.id){
      this.getUnitArr(value.id,false)
    }else{
      this.setState({
        majorArr:[]
      })
    } 
  }
  majorVal = (e) =>{
    const valStr = e.target.value;
    let value=valStr ? JSON.parse(valStr) : "";
    this.setState({
      majorId:value.id,
      majorName:value.name,
      majorVal: valStr
    }) 
  }
  handleSpace = (data) =>{
    return data.replace(/\s+/g,'')!=''?true:false
  }
  findElem = (data) =>{
    let aArr = data.split(",")
    let newArr = []  
    aArr.map(el=>{
      let obj = {}
      if(el=='0'){
        obj ={
          id:el,label:'幼儿园'
        }
      }else if(el=='1'){
        obj ={
          id:el,label:'小学'
        }
      }else if(el=='2'){
        obj ={
          id:el,label:'初中'
        }
      }else if(el=='3'){
        obj ={
          id:el,label:'高中'
        }
      }else if(el=='4'){
        obj ={
          id:el,label:'特殊教育'
        }
      }else if(el=='5'){
        obj ={
          id:el,label:'中职'
        }
      }
      newArr.push(obj)   
    })
    return newArr
  }
  findSubject = (data) =>{
    let aArr = data.split(",")
    let newArr = []  
    aArr.map(el=>{
      let obj = {}
      if(el=='100'){
        obj ={
          id:el,label:'语文'
        }
      }else if(el=='101'){
        obj ={
          id:el,label:'数学'
        }
      }else if(el=='102'){
        obj ={
          id:el,label:'英语'
        }
      }else if(el=='103'){
        obj ={
          id:el,label:'幼儿'
        }
      }else if(el=='104'){
        obj ={
          id:el,label:'音乐'
        }
      }else if(el=='105'){
        obj ={
          id:el,label:'体育'
        }
      }else if(el=='106'){
        obj ={
          id:el,label:'美术'
        }
      }else if(el=='107'){
        obj ={
          id:el,label:'政治'
        }
      }else if(el=='108'){
        obj ={
          id:el,label:'历史'
        }
      }else if(el=='109'){
        obj ={
          id:el,label:'地理'
        }
      }else if(el=='110'){
        obj ={
          id:el,label:'物理'
        }
      }else if(el=='111'){
        obj ={
          id:el,label:'化学'
        }
      }else if(el=='112'){
        obj ={
          id:el,label:'生物'
        }
      }else if(el=='113'){
        obj ={
          id:el,label:'科学'
        }
      }else if(el=='114'){
        obj ={
          id:el,label:'信息技术'
        }
      }else if(el=='115'){
        obj ={
          id:el,label:'特殊教育'
        }
      }else if(el=='116'){
        obj ={
          id:el,label:'心理健康'
        }
      }
      newArr.push(obj)   
    })
    return newArr
  }
  isCkAdr = () =>{
    if((this.state.isArea)/1==0){  
      if(this.ckAdr()){
        return true
      }else{
        return false
      }    
    }else{
      return true
    }
  }
  // && this.ckAdr()
  login = () => {
    if (this.ckName() && this.ckPhone() && this.ckCode()&&this.ckStages()&&this.ckUnit()&&this.ckMajor()&&this.isCkAdr()) {     
      let that = this;
      if (that.state.lockState === false) {
        that.setState({
          lockState: true,
          btnDis: true
        })
        axios.post(storage.baseUrl + '/saveUserInfo', "username=" + that.state.user_name + "&mobile=" + that.state.user_phone + "&code="
          + that.state.user_code + "&provceCode=" + that.state.proVal + "&cityCode=" + that.state.cityVal + "&examTypeId="
          + that.state.examTypeId + "&examId=" + that.state.examId + "&paperId=" + that.state.paperId + "&channel=" + that.state.channel + "&stages=" + that.state.stagesVal + "&subject=" + that.state.subjectVal+ "&unit=" + that.state.unitName+ "&unitId=" + that.state.unitId+"&position=" + that.state.majorName+ "&positionId=" + that.state.majorId+"&market="+that.state.market
        )
          .then(function (response) {
            // return false
            if (response.data.code !== "0000") {
              if (response.data.code === "0101" || response.data.code === "0102") {
                that.setState({
                  jgTxtCode: response.data.msg,
                  codeJg: true
                })
              } else if (response.data.code === "0104") {
                Toast.info('已经答题', 1);
                setTimeout(() => {
                  that.props.history.push({ pathname: "/Result", state: { examType: that.state.examType, examId: response.data.datas.examId, paperId: response.data.datas.paperId, userId: response.data.datas.userId } });
                }, 200);

              }else if (response.data.code === "0107") {

                setTimeout(() => {
                  that.props.history.push({ pathname: "/Countdown", state: { examType: that.state.examType, examId: response.data.datas.examId, paperId: response.data.datas.paperId, userId: response.data.datas.userId } });
                }, 200);

              } else if (response.data.code === "0103") {
                that.setState({
                  jgTxtCode: response.data.msg,
                  codeJg: true
                })

              } else {
                // Toast.info(response.data.msg);
                that.setState({
                  jgTxtPro: response.data.msg,
                  adrJg: true
                })
              }


            } else {
              // Toast.info('登录成功', 1);
              storage.set("loginState", true);
              if (that.state.examType === "0") {
                setTimeout(() => {
                  that.props.history.push({ pathname: "/GF", state: { examType: that.state.examType, examId: response.data.datas.examId, paperId: response.data.datas.paperId, userId: response.data.datas.userId } });

                }, 200);
              } else {
                setTimeout(() => {
                  that.props.history.push({ pathname: "/MK", state: { examType: that.state.examType, examId: response.data.datas.examId, paperId: response.data.datas.paperId, userId: response.data.datas.userId } });

                }, 200);
              }

            }
            setTimeout(() => {
              that.setState({
                lockState: false,
                btnDis: false
              })
            }, 2000)
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          })

      }



    }

  }
  toyy = () => {

    setTimeout(() => {
      this.props.history.replace(`/Ylogin?examId=${this.state.examId}&paperId=${this.state.paperId}`);
    });


  }
  handleChange = (val)=>{
    // /unitList?unitName=鹤壁
    // console.log(val,'4444444444444')
    // this.getUnitArr(val.target.val)
  }
  // onSearch = (val)=>{
    
  //   this.getUnitArr(val,true)
  // }
  // onSelect = (val, option)=>{
  //   // console.log(option,'option')
  //   this.setState({
  //     unitVal:val,
  //     unitId:option.value,
  //     unitName:option.label
  //   })
  //   this.getUnitArr(val,false)
  // }
  getUnitArr = (data,blu)=>{
    let that = this
    let params = blu?{examId:data,pid:0}:{pid: data}
    axios.get(storage.baseUrl + '/unitList', {
      params: params
    })
      .then(function (response) {
        if(blu){
          that.setState({
            unitArr:response.data.regnInfos
          })
        }else{
          that.setState({
            majorArr:response.data.regnInfos
          })
        }  
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
  }
  render() {


    return (
      <div className="login_con">
        <img src={logo} className="res_logo" alt="logo" />
        <div className="gf_title">{this.state.paperInfo.examName}{this.state.paperInfo.paperName}</div>
        {
          this.state.examType === "0" ?
            <p className="gf_tip">(内置详细真题参考答案及解析）</p> :
            <p className="gf_tip">(内置详细参考答案及解析）</p>
        }

        <WhiteSpace size="sm"></WhiteSpace>
        <p className="user_in">
          <i></i>
          <input type="text" placeholder='请输入昵称' onChange={this.userName} ref="nameVal" autoFocus maxLength="16" />

          <span className={this.state.nameJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxt}</span>


        </p>
        <p className="phone_in">
          <i></i>
          <input type="text" placeholder='请输入您的电话号码' onChange={this.userPhone} ref="phoneVal" autoFocus maxLength="11" />
          <span className={this.state.phoneJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxtPhone}</span>
        </p>
        <p className="code_in">
          <i></i>
          <input type="text" placeholder='请输入验证码' onChange={this.userCode} ref="codeVal" autoFocus maxLength="6" />
          <button className="get_code" onClick={this.getcode} disabled={this.state.codeDis}>{this.state.code_num}</button>
          <span className={this.state.codeJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxtCode}</span>
        </p>
        <p className={this.state.stagesArr.length>0||this.state.subjectArr.length>0?"sub_in":"none"}>
          <i className={this.state.stagesArr.length==0&&this.state.subjectArr.length==0?"none":"subject_ico"}></i>
          <select ref="StagesVal" className={this.state.stagesArr.length>0&&this.state.subjectArr.length>0?"stategs_in":this.state.stagesArr.length>0?"stategsAll_in":"none"} value={this.state.stagesVal} onChange={this.stagesVal}  >
            <option value="" selected>请选择学段</option>
            
            {
              this.state.stagesArr.map((val, key) => {
                return (
                  <option value={val.id} key={key}>{val.label}</option>
                )
              })
            }
          </select>
          <i className={this.state.stagesArr.length>0&&this.state.subjectArr.length>0?"stages_i":"none"}></i>
          <select ref="SubjectVal" className={this.state.stagesArr.length>0&&this.state.subjectArr.length>0?"subject_in":this.state.subjectArr.length>0?"subjectAll_in":"none"} value={this.state.subjectVal} onChange={this.subjectVal} >
            <option value="" selected>请选择学科</option>
            {
              this.state.subjectArr.map((val, key) => {
                return (
                  <option value={val.id} key={key}>{val.label}</option>
                )

              })
            }
          </select>
          <i className={this.state.stagesArr.length==0&&this.state.subjectArr.length==0?"none":"subject_i"}></i>
          <span className={this.state.subJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxtSub}</span>
        </p>
        <div className={this.state.examTypeId=='1036'?"unit_in":"none"}>
          <i className="unit_ico"></i>
          <select ref="unitVal" className="unitAll_in" value={this.state.unitVal} onChange={this.unitVal}  >
            <option value="" selected>请选择单位</option>      
            {
              this.state.unitArr.map((val, key) => {
                return (
                  <option value={JSON.stringify(val)} key={key}>{val.name}</option>
                )
              })
            }

          </select>
          {/* <Select placeholder={"请手动输入，例如：郑州"} showSearch allowClear value={this.state.unitVal} filterOption={false}
            onChange={this.handleChange}
            onSearch={this.onSearch}
            notFoundContent={"暂无数据"}
            onSelect={this.onSelect}
            options={(this.state.unitArr || []).map((d) => ({ value: d.id,  label: d.name, pid: d.pid}))}
          /> */}
          <i className="unit_i"></i> 
          <span className={this.state.unitJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxtUnit}</span>
        </div>
        <p className={this.state.examTypeId=='1036'?"major_in":"none"}>
          <i className="major_ico"></i>
          <select ref="MajorVal" className="majorAll_in" value={this.state.majorVal} onChange={this.majorVal}>
            <option value="" selected>请选择专业</option>
            {
              this.state.majorArr.map((val, key) => {
                return (
                  <option value={JSON.stringify(val)} key={key} >{val.name}</option>
                )
              })
            }

          </select>
          <i className="major_i"></i>
          <span className={this.state.majorJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxtMajor}</span>
        </p>
        <p className={(this.state.isArea)/1 === 0 ? "adr_in" :"adr_in none"} >
          <i className="adr_ico"></i>
          <select ref="ProVal" className="pro_in" value={this.state.proVal} onChange={this.proVal}  >
            <option value="" selected>请选择报考省份</option>
            {
              this.state.pro_list.map((val, key) => {
                return (
                  <option value={val.regnCode} key={key}>{val.regnNm}</option>
                )
              })
            }

          </select>
          <i className="pro_i"></i>
          <select ref="CityVal" className="city_in" value={this.state.cityVal} onChange={this.cityVal} >
            <option value="" selected>报考市区</option>
            {
              this.state.city_list.map((val, key) => {
                return (
                  <option value={val.regnCode} key={key}>{val.regnNm}</option>
                )

              })
            }
          </select>
          <i className="city_i"></i>
          <span className={this.state.adrJg === true ? "jg_txt" : "jg_txt none"}>{this.state.jgTxtPro}</span>
        </p>
        <p className="login_tip"><span className="userNum">{this.state.paperInfo.questionsComment}</span></p>
        {
          this.state.examType === "0" ?
            <button type="primary" onClick={this.login} className="to_gf" disabled={this.state.btnDis}>立即估分</button> :
            <button type="primary" onClick={this.login} className="to_gf" disabled={this.state.btnDis}>立即模考</button>
        }

        <button type="primary" onClick={this.toyy} className="to_yy">已预约</button>
      </div>
    );
  }
}

export default Login;
